<template>
  <div id="pendingApproval" class="common_contentBox">
    <commonHeader
      :tabs-list="tabsList"
      :tabs-default="form.activityStatus"
      @handleTabsClick="handleTabsClick"
      :breadcrumb-show="false"
      :tabs-quantity-show="true"
      v-if="$store.state.userInfo.userType === 'rj'"
    />
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">{{ $t('approvalCenter.ActivityNumber') }}：</div>
          <div class="content">
            <el-input v-model="form.activityCode" @input="inputBoxFilter($event,'activityCode')" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">{{ $t('approvalCenter.EventName') }}：</div>
          <div class="content">
            <el-input v-model="form.activityName" @input="inputBoxFilter($event,'activityName')" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">{{ $t('approvalCenter.TypeOfActivity') }}：</div>
          <div class="content">
            <el-input v-model="form.activityType" @input="inputBoxFilter($event,'activityType')" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('approvalCenter.TheApplicant') }}：</span>
          <div class="content">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')" @input="inputBoxFilter($event,'applyUserNameOrId')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('approvalCenter.CorrespondingSales') }}：</span>
          <div class="content">
            <el-input v-model="form.salerNameOrId" :placeholder="$t('general.pec')" @input="inputBoxFilter($event,'salerNameOrId')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('approvalCenter.Department') }}：</span>
          <div class="content">
            <el-select
              v-model="form.applyUserDeptNameOrCode"
              filterable
              remote
              clearable
              reserve-keyword
              :placeholder="$t('general.pec')"
              :remote-method="getApplyDeptList"
              :loading="applyLoading"
            >
              <el-option v-for="item in applyDeptList" :key="item.userId" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('newApp.Attribute.cad') }}：</span>
          <div class="content">
            <el-select
              v-model="form.expenseDeptNameOrCode"
              filterable
              remote
              clearable
              reserve-keyword
              :placeholder="$t('general.pec')"
              :remote-method="getCostDeptList"
              :loading="applyLoading"
            >
              <el-option v-for="item in costDeptList" :key="item.userId" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('approvalCenter.TypeFee') }}：</div>
          <div class="content">
            <el-select v-model="form.expenseTypeCode" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in expenseTypeList" :key="item.expenseTypeCode" :label="item.expenseTypeName" :value="item.expenseTypeCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-if="isBrandPromotion" v-show="searchOpenFlag">
          <div class="label">{{ $t('approvalCenter.StatusMaterial') }}：</div>
          <div class="content">
            <el-select v-model="form.materialConfigStat" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in materialStatusList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-if="form.activityStatus == 0" v-show="searchOpenFlag">
          <div class="label">{{ $t('industryReport.hybblb.list.bblx') }}：</div>
          <div class="content">
            <el-select v-model="form.reportType" :placeholder="$t('industryReport.hybblb.tsy.bblx')" clearable>
              <el-option v-for="item in reportingTypeList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.coa') }}：</div>
          <div class="content">
            <el-select
              v-model="form.activityClassification"
              clearable
              :placeholder="$t('general.ps')"
              @change="searchBtn"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <!-- 总部活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.headquarterActivityName') }}：</div>
          <div class="content">
            <el-input v-model="form.hqActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <!-- 模板活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.templateActivityName') }}：</div>
          <div class="content">
            <el-input v-model="form.templateActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button
            type="primary"
            @click="handleBatchApproval"
            v-if="form.activityStatus === '1' && isBatchApprove"
          >
            {{ $t('approvalCenter.StatusMaterial') }}
          </el-button>
          <el-button plain @click="reset">{{ $t('btn.Reset') }}</el-button>
          <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? $t('btn.CollspseS') : $t('btn.AdvancedS') }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <div v-show="form.activityStatus !== '2'" class="common_group">
      <commonTable ref="approvalCostTable" />
    </div>
    <commonTable
      ref="pendingApprovalTable"
      :is-choice-flag="true"
      @handleSelectChange="selectChangeCommand"
      @handleCheckBoxAll="selectChangeCommand"
      @handleTableList="getTableListCommand"
      :whether-check-method="whetherCheckMethod"
    />
    <!-- 活动评估 -->
    <assessmentDialog
      :activity-code="currentActivityCode"
      :assessment-dialog-visible="assessmentDialogVisible"
      @dialogCloseHandle="assessmentDialogClose"
      @handlerSuccess="assessmentSuccess"
    />
    <agreeDialog
      :approved="approved"
      :dialog-title="agreeDialogTitle"
      :echo-data="echoData"
      :agree-dialog-visible="agreeDialogVisible"
      @agreeSubHandle="agreeSubHandle"
      @dialogCloseHandle="agreeDialogCloseHandle"
    />
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { isNotEmpty } from '@/utils/utils.js';
import { approvalCenterApi } from './service';
import { newApplicationFormApi } from '../newApplicationForm/service';
import assessmentDialog from '../activitieList/component/reportList/assessmentDialog';
import { activityQuery, activityQueryDetails } from '../activitieList/service';
import agreeDialog from '@/views/activitieList/component/activityDetails/activistyCostAttribution/agreeDialog';
import { mapState } from 'vuex';
export default {
  name: 'PendingApproval',
  data () {
    return {
      reportingTypeList: [
        {
          label: this.$t('industryReport.hybblb.cxtj.qybb'),
          val: 1
        },
        {
          label: this.$t('industryReport.hybblb.cxtj.hybb'),
          val: 2
        }
      ],
      searchOpenFlag: false,
      tabsList: [
        {
          label: this.$t('approvalCenter.ActivityApplication'),
          name: '1'
        }
      ],
      form: {
        approvalStat: 1, // 待审批
        activityStatus: '1',
        reportType: '' // 报备类型
      },
      tableData: [],
      tableParams: {},
      costList: [],
      assessmentDialogVisible: false,
      currentActivityCode: '',
      applyDeptList: [],
      applyLoading: false,
      costDeptList: [],
      expenseTypeList: [],
      activityClassificationList: [],
      isBrandPromotion: false,
      materialStatusList: [
        {
          label: this.$t('eventList.Configured'),
          val: '1'
        },
        {
          label: this.$t('eventList.NotCon'),
          val: '0'
        }
      ],
      activityCodeList: [], // 活动编号集合
      taskIds: [], // 审批id
      approved: '', // 当前用户信息
      echoData: {},
      agreeDialogTitle: '同意',
      agreeDialogVisible: false,
      isBatchApprove: false, // 是否批量审批
      isCompliance: false // 是否合规申请
    };
  },
  components: {
    commonTable,
    agreeDialog,
    commonHeader,
    assessmentDialog
  },
  computed: {
    ...mapState({
      pendingApprovalNum: state => state.pendingApprovalNum
    })
  },
  watch: {
    pendingApprovalNum: {
      handler (data) {
        this.setPendingQuantity(data);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getCostDeptList (expenseKey) {
      if (expenseKey && expenseKey.indexOf(' ') === 0) {
        this.costDeptList = [];
        return;
      }
      expenseKey = expenseKey || 'all';
      let params = {
        type: 'EXPENSE',
        key: expenseKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getApplyDeptList (applyKey) {
      if (applyKey && applyKey.indexOf(' ') === 0) {
        this.applyDeptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.applyDeptList = res.data;
        }
      });
    },
    assessmentSuccess () {
      this.assessmentDialogVisible = false;
      this.searchBtn();
    },
    assessmentHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.assessmentDialogVisible = true;
    },
    assessmentDialogClose () {
      this.assessmentDialogVisible = false;
    },
    handleTabsClick (data) {
      this.$set(this.form, 'activityStatus', data.name);
      this.searchBtn();
    },
    inputBoxFilter (val, key) {
      let numVal = val.replace(/^\s+|\s+$/g, '');
      this.$set(this.form, key, numVal);
    },
    approvalHandle (row) {
      // 如果是报备则跳转报备详情，否跳转至活动详情
      if (this.form.activityStatus === '0') {
        let path = '/reportDetails';
        if (row.reportType) {
          path = row.reportType === '1' ? '/regionReportDetails' : '/industryReportDetails';
        }
        this.$router.push({
          path: path,
          query: {
            activityCode: row.activityCode,
            metaActive: '/pendingApproval'
          }
        });
        return;
      }
      this.$router.push({
        path: '/activityDetails',
        query: {
          activityCode: row.activityCode,
          metaActive: '/pendingApproval'
        }
      });
    },
    reset () {
      this.form = {
        approvalStat: 1,
        activityStatus: this.form.activityStatus
      };
      this.searchBtn();
    },
    searchBtn () {
      this.getCostList(this.form.activityStatus);
      // this.$refs.pendingApprovalTable.getTableData({ url: '/approvecenter/wait_tasks', params: this.form });
      if (this.form.activityStatus === '2') {
        this.$refs.pendingApprovalTable.loadTable({
          url: '/compliance/approve/wait_tasks',
          listKey: 'list',
          params: this.form
        });
      } else {
        this.loadTable();
      }
    },
    // 获取表格数据
    getTableListCommand (data) {
      this.isBatchApprove = data.some(item => item.isBatchApprove === 1 && item.isApproveTask === 1);
      this.loadTable('checkUpdate');
    },
    // 表格选中事件
    selectChangeCommand (e) {
      this.activityCodeList = e.selection.map(item => item.activityCode);
      this.taskIds = e.selection.map(item => item.taskId);
    },
    // 表格选中禁用
    whetherCheckMethod ({ row }) {
      return row.isBatchApprove === 1 && row.isApproveTask === 1;
    },
    // 批量审批事件
    handleBatchApproval () {
      if (!isNotEmpty(this.activityCodeList)) {
        this.$alert('请选择审批进行操作！', '提示', {
          confirmButtonText: '确定'
        });
      } else {
        activityQueryDetails
          .getBasicInfoData(this.activityCodeList[0])
          .then(res => {
            if (res.status === '200') {
              this.echoData = res.data;
              const {
                id
              } = res.data.mactExpenseBelongVOList[0].mactExpenseBelong;
              activityQueryDetails.getProcessHistory(id).then(res => {
                if (res.status === '200') {
                  let { mactFlowLogList } = res.data;
                  this.approved =
                    mactFlowLogList[mactFlowLogList.length - 1].assigneeName;
                  this.agreeDialogVisible = true;
                }
              });
            }
          });
      }
    },
    agreeSubHandle (data) {
      const params = {
        reason: data.reason === '同意' ? '' : data.reason,
        directors: data.directors,
        taskIds: this.taskIds,
        activityCodeList: this.activityCodeList
      };
      activityQueryDetails.activistyCostApproval(params).then(res => {
        if (res.status === '200') {
          this.agreeDialogVisible = false;
          this.$message.success(this.$t('general.AppSucc'));
          this.$refs.pendingApprovalTable.loadTable({
            url: '/approvecenter/wait_tasks',
            listKey: 'list',
            params: this.form
          });
        }
      });
    },
    agreeDialogCloseHandle () {
      this.agreeDialogVisible = false;
    },
    loadTable (type) {
      let tableRow = new TableRow();
      if (this.form.activityStatus === '1' && this.isBatchApprove) {
        tableRow.push(
          new TableColumns()
            ._width('6%')
            ._fixed('left')
            ._others('checkbox')
        );
      }
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.ActivityNumber'))
          ._width('140')
          ._data('activityCode')
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <span class="btnText" type="text" onClick={() => { this.approvalHandle(row); }}>{ row.activityCode }</span>
              );
            }
          })
      );
      if (this.form.activityStatus === '1') {
        tableRow.push(
          new TableColumns()
            ._width('140px')
            ._title(this.$t('eventList.Afc'))
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                let text = this.$t('home.ea');
                switch (row.submitType) {
                  case 'report_submit':
                    text = this.$t('home.aff');
                    break;
                  case 'quick_submit':
                    text = this.$t('home.qa');
                    break;
                  case 'qd_submit':
                    text = this.$t('home.ca');
                    break;
                }
                return (
                  <div>{ text }</div>
                );
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TheApplicant'))
          ._width('110')
          ._data('applyUserName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.CorrespondingSales'))
          ._width('150')
          ._data('salerName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.Department'))
          ._width('120')
          ._data('salerDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.EventName'))
          ._width('200')
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TypeOfActivity'))
          ._width('120')
          ._data('activityType')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TimeApplication'))
          ._width('150')
          ._data('applyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.MarketingExpenses'))
          ._width('150')
          ._align('right')
          ._data('marketingCost')
      );
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('approvalCenter.DegreeImportance'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{ row.importance ? row.importance : this.$t('eventList.NotEva') }</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('140')
          ._title(this.$t('approvalCenter.AbilityExecute'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{ row.enforceability ? row.enforceability : this.$t('eventList.NotEva') }</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('150')
          ._title(this.$t('approvalCenter.StrengthSupport'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{ row.supportStrength ? row.supportStrength : this.$t('eventList.NotEva') }</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('160')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let userInfo = this.$store.state.userInfo;
              return (
                <div>
                  <el-button type="text" onClick={() => { this.approvalHandle(row); }}>{ this.$t('approvalCenter.ToDealWith') }</el-button>
                  {
                    userInfo.sysUser.deptCode.indexOf('000013') === 0 ? (
                      <el-button type="text" onClick={ () => { this.assessmentHandler(row); } }>{this.$t('btn.ActivityE')}</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.pendingApprovalTable.setColumn(column);
      if (!type) {
        this.$refs.pendingApprovalTable.loadTable({
          url: '/approvecenter/wait_tasks',
          listKey: 'list',
          params: this.form
        });
      }
    },
    loadCostTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.ExpenseDepartment'))
          ._width('8%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TypeFee'))
          ._width('8%')
          ._data('expenseTypeName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.AnnualBudget'))
          ._width('8%')
          ._data('budget')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.BalanceBudget'))
          ._width('8%')
          ._data('realBudget')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.NumberApprovals'))
          ._width('8%')
          ._data('approvedCount')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.AmountApprovals'))
          ._width('10%')
          ._data('approvedBudget')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter._NumberApprovals'))
          ._width('8%')
          ._data('approvalPendingCount')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter._AmountApprovals'))
          ._width('10%')
          ._data('approvalPendingBudget')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.approvalCostTable.setColumn(column, {
          page: false
        });
        this.$refs.approvalCostTable.loadStaticTable(this.costList);
      });
    },
    getCostList (activityStatus) {
      approvalCenterApi.getCostList(activityStatus).then(res => {
        if (res.status === '200') {
          this.costList = res.data;
          this.loadCostTable();
        }
      });
    },
    getExpenseTypeList () {
      activityQuery.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    },
    getActivityCommonList () {
      if (this.activityClassificationList.length > 0) {
        return;
      }
      const params = [
        'activity_classification'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityClassificationList = res.data.activity_classification || [];
        }
      });
    },
    setPendingQuantity (data) {
      if (data) {
        const reportTab = this.tabsList.find(item => item.name === '0');
        const applyTab = this.tabsList.find(item => item.name === '1');
        if (reportTab) this.$set(reportTab, 'quantity', data.reportCount);
        if (applyTab) this.$set(applyTab, 'quantity', data.applyCount);
        this.getIsCompliance(data);
      }
    },
    // 根据合规申请查看权限决定是否增加合规申请tab页签
    getIsCompliance (data) {
      approvalCenterApi.getComplianceShowPrivilege().then(res => {
        if (res.status === '200') {
          this.isCompliance = res.data;
          if (res.data) {
            const index = this.tabsList.findIndex(item => item.name === '2');
            console.log(index, data);
            if (index === -1) {
              this.tabsList.push({
                label: this.$t('approvalCenter.ComplianceApplication'),
                name: '2',
                quantity: data.complianceApplyCount
              });
            } else {
              this.$set(this.tabsList[index], 'quantity', data.complianceApplyCount);
            }
          }
        }
      });
    }
  },
  activated () {
    this.setPendingQuantity(this.pendingApprovalNum);
    if (this.form.activityStatus === '2') {
      this.$refs.pendingApprovalTable.loadTable({
        url: '/compliance/approve/wait_tasks',
        listKey: 'list',
        params: this.form
      });
    } else {
      this.loadTable();
    }
    this.loadCostTable();
    this.getCostList(this.form.activityStatus);
    this.getExpenseTypeList();
    this.getActivityCommonList();
  },
  mounted () {
    this.isBrandPromotion = this.$store.state.userInfo.belongToBrandPromotionDept;
    if (this.$store.state.userInfo.userType === 'rj') {
      this.tabsList.unshift({
        label: this.$t('approvalCenter.ReportActivity'),
        name: '0',
        hidden: this.$store.state.useSimplifiedUI
      });
      // 简化UI用户不默认选中报备Tab，保持默认的活动申请Tab
      if (!this.$store.state.useSimplifiedUI) {
        this.form.activityStatus = '0';
      }
    }
    this.getActivityCommonList();
  }
};
</script>
<style lang="scss" scoped>
#pendingApproval {
  width: 100%;
}
</style>
